var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.25h7.5v-1.5h-7.5zm0-3h11.5v-1.5H3.75zm0-3h11.5v-1.5H3.75zM0 18.539V1.807Q0 1.05.525.525T1.808 0h15.384q.758 0 1.283.525T19 1.808v11.384q0 .758-.525 1.283T17.192 15H3.538zM2.9 13.5h14.292a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V1.808a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H1.808a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.077z"
  })));
};
export default SvgChat;